import React from 'react';
import './footer.scss';

export default function Footer () {
    return <div className='footer'>
        <p> Contact </p>
        <p> About </p>
    </div>
}